import React , {Fragment} from 'react'
import {Col,Button,Form, Row, Modal} from 'react-bootstrap';
import { Formik } from 'formik';
import {useSelector} from 'react-redux';
import {AddDeductEarning} from '../../entities/action/action';

export default function DeductAmount(props){
    const userData = useSelector(state=>state.adminAccount.apiResponse);
    return(
       <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Deduct Amount
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Formik
            initialValues={{eWallet:'',amountType:'E-wallet',remarks:''}}
            onSubmit={
                async(values,{setSubmitting})=>{
                    setSubmitting(true);
                    const amount = Math.abs(Number(values.eWallet));
                    const newData = {
                        "amount": Math.ceil(amount * 100),
                        "credit": false,
                        "custEmailId": props.data.email,
                        "debit": true,
                        "emailId": userData?.data?.key,
                        "message": values.remarks,
                        "sessionKey": userData?.sessionId,
                        "type": "E-wallet",
                        "userId": props.data.id
                    }
                    const response = await AddDeductEarning(newData, "E-wallet");
                    if(response?.success){
                        alert("Successfully deducted amount from wallet");
                        window.location.reload();
                    } else {
                        alert(response?.message || "Failed to deduct amount");
                    }
                    setSubmitting(false);
                }
            }
            >
                {
                            ({values,handleChange,handleBlur,handleSubmit,isSubmitting})=>(
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group controlId="formBasicAmount">
                                        <Form.Label>Deduct E-Wallet Amount (INR):</Form.Label>
                                        <Form.Control 
                                        type="Number"
                                        step="any" 
                                        placeholder="Amount to deduct (can take wallet negative)" 
                                        name="eWallet"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.eWallet}
                                        required
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="formBasicRemarks">
                                        <Form.Label>Remarks:</Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        placeholder="e.g. Manual booking on partner site" 
                                        name="remarks"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.remarks}
                                        required
                                        />
                                    </Form.Group>
                                    <center>
                                        <Button variant="success" style={{margin:'2%'}} type="submit" disabled={isSubmitting}>
                                            Submit
                                        </Button>
                                        <Button onClick={props.onHide} style={{margin:'2%'}}>Close</Button>
                                    </center>
                                </Form>
                            )
                            }
            </Formik>
        </Modal.Body>
      </Modal>
    );
}


